import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FeedbackMappingModel } from 'common/models/page-models/Feedback-Mapping/feedback-mapping-data-model';
import { FeedbackMappingListingModel } from 'common/models/page-models/Feedback-Mapping/feedback-mapping-grid-model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { FeedbackMappingGridWidgetService } from 'common/widget/feedback-mapping/feedback-mapping-grid-widget.service';

@Injectable({
    providedIn: 'root'
})
export class FeedbackMappingGridResolver extends GridResolver<FeedbackMappingModel, FeedbackMappingListingModel> {
    constructor(
        protected fs:FeedbackMappingGridWidgetService,
        protected override  router: Router,
        protected override  systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}
